module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//red_1.png?v=a76332b0";